import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

/** Helper functions related to the application environment */
@Injectable({
  providedIn: 'root'
})
export class EnvironmentHelperService {
  public get isIframed(): boolean {
    try {
      // tslint:disable-next-line: strict-comparisons
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }

  public get isLocal(): boolean {
    return window.location.hostname === 'localhost';
  }

  public get hostOrigin(): string {
    if (this.isLocal && 'hostOrigin' in environment) {
      // Use environment variable to determine origin based on start script context (ifc wrapper vs web-directory)
      return environment.hostOrigin;
    }

    // In all other environments host origin should be the same as the client app origin
    return window.location.origin;
  }

  /** Returns the client origin, using a hardcoded value for the local environment to direct to the local proxy for the public api */
  public get clientOrigin(): string {
    if (this.isLocal && 'proxyOrigin' in environment) {
      return environment.proxyOrigin;
    }

    return window.location.origin;
  }

  public get appVersion(): string {
    return environment.appVersion;
  }
}
